import React from 'react';
import { Mail, Phone } from 'lucide-react';

export const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="relative border-t border-white/10 bg-black">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid md:grid-cols-4 gap-8 md:gap-12 mb-8 md:mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <img 
              src="https://customer-assets.emergentagent.com/job_revotech-preview/artifacts/irwgjbpt_10x%20black%20background%20and%20white%20text.png" 
              alt="RevoTech" 
              className="h-8 md:h-10 mb-3 md:mb-4" 
            />
            <p className="text-sm md:text-base text-white/70 mb-3 md:mb-4 max-w-md">
              Driving Impact Through Revolutionary Technologies
            </p>
            <p className="text-sm md:text-base text-[#5B42FF] font-medium">
              Built in Saudi Arabia. Designed to change the world.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-base md:text-lg text-white font-semibold mb-3 md:mb-4">Quick Links</h4>
            <ul className="space-y-2 md:space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-sm md:text-base text-white/70 hover:text-[#5B42FF] transition-colors duration-300"
                >
                  About
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-sm md:text-base text-white/70 hover:text-[#5B42FF] transition-colors duration-300"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('partners')}
                  className="text-sm md:text-base text-white/70 hover:text-[#5B42FF] transition-colors duration-300"
                >
                  Partners
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-sm md:text-base text-white/70 hover:text-[#5B42FF] transition-colors duration-300"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-base md:text-lg text-white font-semibold mb-3 md:mb-4">Contact</h4>
            <ul className="space-y-2 md:space-y-3">
              <li>
                <a
                  href="mailto:info@RevoTech.sa"
                  className="text-sm md:text-base text-white/70 hover:text-[#5B42FF] transition-colors duration-300 flex items-center space-x-2"
                >
                  <Mail className="w-3 h-3 md:w-4 md:h-4" />
                  <span className="break-all">info@RevoTech.sa</span>
                </a>
              </li>
              <li>
                <a
                  href="tel:+966554855969"
                  className="text-sm md:text-base text-white/70 hover:text-[#5B42FF] transition-colors duration-300 flex items-center space-x-2"
                >
                  <Phone className="w-3 h-3 md:w-4 md:h-4" />
                  <span>+966 55 48 55 969</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 md:pt-8 border-t border-white/10">
          <p className="text-center text-white/60 text-xs md:text-sm">
            © 2026 RevoTech. All rights reserved.
          </p>
        </div>
      </div>

      {/* Background Accent */}
      <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-64 md:w-96 h-24 md:h-32 bg-[#5B42FF]/5 rounded-full blur-3xl"></div>
    </footer>
  );
};
